import type { Plan } from "./Plan";

export enum SubscriptionStatus {
  ACTIVE = "active",
  CANCELED = "canceled",
  PAST_DUE = "past_due",
  INACTIVE = "inactive",
  INCOMPLETE = "incomplete",
}

export enum SubscriptionStateId {
  ACTIVE = 0, //0 -> Suscripcion activa - Fecha renovación
  ACTIVE_CHANGE_PLAN = 1, //1 -> Suscripción activa pero con cambio de plan - Fecha renovación
  CANCELED = 2, //2 -> Suscripción activa cancelada - Fecha finalización
  PENDING_RENEW = 3, //3 -> Suscripción pendiente de renovar - Sin fecha
}

export interface ReducedPlan {
  title?: string;
  detail?: string;
  description?: string;
  price?: number;
  uuid?: string;
}

export interface Subscription {
  cancelDate: number | null;
  cancelRequested: boolean;
  end: number;
  invoiceStripeId: string;
  isPromo: boolean;
  nextPlanUuid: string;
  planUuid: string;
  start: number;
  status: SubscriptionStatus;
  stripeId: string;
  subscriptionState: { id: SubscriptionStateId; metadata: string; date: number };
  date: number;
  id: number;
  metadata: number;
  userUuid: string;
  uuid: string;
  videoCalls: number;
  paymentIntent: {
    lastPaymentError: { code: string; declineCode: string; message: string };
    status: string;
  };
  plan?: Plan;
  maxSessions: number;
  numSessions: number;
  canSubscribe: boolean;
  reducedPlan: ReducedPlan | null;
}

export interface SubscribeUiQuery {
  planId: string;
  promoPlanId?: string | null;
  userId: string;
}
